import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityCardAiAgent: ExtensionDefinition = EntityCardBlueprint.make({
  name: 'ai-agent-card',
  params: {
    filter: {
      kind: 'AiResource',
      'spec.type': 'agent',
    },
    loader: async () => import('./ai-agent-card').then(m => <m.AiAgentCard />),
  },
});
